import React from "react";
import { Button } from "reactstrap";
import { FaFileExcel } from "react-icons/fa";

export const ExcelExportButton = ({ onClick, title = "Export Excel" }) => (
  <Button
    color="success"
    className="btn p-1 d-flex align-items-center justify-content-center"
    size="sm"
    outline
    onClick={onClick}
    title={title}
    aria-label={title}
  >
    <FaFileExcel size={14} />
  </Button>
);
